export default function videoSection() {

  const videoPopup = document.getElementById('videoWindow');
  if (!videoPopup) return;

  const videoFrame = videoPopup.querySelector('iframe');

  const openVideo = url => {

    // console.log('url', url);

    if (!url) return;

    videoPopup.classList.add('open');
    videoPopup.classList.remove('closed');

    videoFrame.setAttribute('src', url.split('?')[0] + '?autoplay=1'); // strip any query parameters (rough)

    document.body.classList.toggle('locked');
  }
  
  const closeVideo = () => {

    videoPopup.classList.remove('open');
    videoPopup.classList.add('closed');

    setTimeout(() => { // reset src after fadeout
      videoFrame.setAttribute('src', '');
    }, 700);

    document.body.classList.toggle('locked');
  }

  /** close the video on general click */
  videoPopup.addEventListener('click', event => {
    closeVideo();
  });

  /** click the play button */
  const videoLinks = document.querySelectorAll('[data-video-url]');
  videoLinks.forEach(videoLink => {
    videoLink.addEventListener('click', event => {
      openVideo(videoLink.dataset.videoUrl);
    });
  });
}


// WEBPACK FOOTER //
// ./source/scripts/sections/video.js